import * as ko from "knockout";
import Bao from "./../services/bao-service";
import baoRouter from "./../services/bao-router";
function BaoDocumentViewModel(tabPage) {
    var self = this;
    self.TabPage = tabPage;
    self.DocumentFound = ko.observable(false);
    self.FileId = ko.observable();
}
BaoDocumentViewModel.prototype.Download = function () {
    var self = this;
    if (self.DocumentFound(true)) {
        window.open(window.absolutePath + "BaoDocument/Download/" + self.FileId(), "_blank");
    }
};
BaoDocumentViewModel.prototype.loaded = function () {
    var self = this;
    if (self.DocumentFound()) {
        self.Download();
    }
};
BaoDocumentViewModel.prototype.getFileId = function () {
    var self = this;
    var id = self.TabPage.ObjectId();
    var docid = baoRouter.getRouteValue("docid", self.TabPage);
    if (docid != null && docid != "") {
        id = docid;
    }
    return id;
};
BaoDocumentViewModel.prototype.init = function () {
    var self = this;
    self.TabPage.Title("Download");
    var fileName = baoRouter.getRouteValue("fileName", self.TabPage);
    if (fileName != null && fileName != "") {
        var ids = baoRouter.getRouteValue("id", self.TabPage);
        return Bao.post("BaoDocument/CreateZip", JSON.stringify({
            fileName: fileName,
            ids: ids
        }), function (result) {
            if (result.Result == true) {
                self.FileId(result.Message);
                self.DocumentFound(true);
            }
        });
    }
    else {
        var id = self.getFileId();
        return Bao.post("BaoDocument/Get", JSON.stringify({
            id: id
        }), function (result) {
            if (result == true) {
                self.FileId(id);
                self.DocumentFound(true);
            }
        });
    }
};
export default BaoDocumentViewModel;